import React from 'react'
import { Link } from 'react-router-dom'
import { FiExternalLink, FiMapPin, FiPlusCircle, FiClock } from 'react-icons/fi'

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-brand">
          <Link to="/" onClick={scrollToTop} className="footer-logo-link">
            <img src="/images/logoadhoc.svg" alt="Logo ADHOC" className="footer-logo" />
          </Link>
          <p className="footer-tagline">
            Centro de soporte técnico de Agencia Adhoc. Crea tickets, sigue su progreso y
            comunícate directamente con nuestro equipo.
          </p>
          <div className="footer-schedule">
            <FiClock />
            <span>Lunes a viernes, horario de oficina</span>
          </div>
        </div>

        <div className="footer-column">
          <h4>Soporte</h4>
          <Link to="/nuevo-ticket"><FiPlusCircle /> Crear ticket</Link>
          <Link to="/" onClick={scrollToTop}>Inicio</Link>
        </div>

        <div className="footer-column">
          <h4>Agencia Adhoc</h4>
          <a href="https://www.agenciaadhoc.com" target="_blank" rel="noopener noreferrer">
            <FiExternalLink /> www.agenciaadhoc.com
          </a>
          <a href="https://agenciaadhoc.com/contacto" target="_blank" rel="noopener noreferrer">
            <FiMapPin /> Contacta con nosotros
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {year} Agencia Adhoc. Todos los derechos reservados.</p>
      </div>
    </footer>
  )
}

export default Footer
